<script>
export const pageName = 'admin';
export const pageRoute = '/admin';
export const title = 'Admin'
export const requireAdmin = true;
export const requireEmailVerified = false;

import { hideLoading, showLoading } from '../../js/utils/loading.js';
import { getUserViewByEmail, getUserViewByNumber, searchUserViewsByName } from '../../js/readModel.js';
import { navigate } from '@trullock/page-manager'
import { listenForProjections } from '@trullock/firebase-client';
import PendingCertificationAttempt from '../../../functions/domain/users/pendingCertificationAttempt.js';
import PendingMAPAttempt from '../../../functions/domain/users/pendingMAPAttempt.js';
import { showToast } from '../../js/utils/toast.js'
import { certLevelToLevel } from '../../../functions/domain/certification-utils.js';
import PendingRecordAttempt from '../../../functions/domain/users/pendingRecordAttempt.js';

export default {
	data() {
		return { 
			searchTerm: "",
			searchResults: [],
			pendingAttempts: [],
			pendingMAPAttempts: [],
			pendingRecordAttempts: [],
			ready: false
		}
	},

	methods: {
		async boot(opts) {
			await listenForProjections([PendingCertificationAttempt], this.pendingAttempts);
			await listenForProjections([PendingMAPAttempt], this.pendingMAPAttempts);
			await listenForProjections([PendingRecordAttempt], this.pendingRecordAttempts);
			this.ready = true;
		},
		search: async function() {
			showLoading();

			let user = null;
			this.searchResults = []

			let term = this.searchTerm.trim().toLowerCase();

			let matches = term.match(/^\#?(\d+)$/)
			

			if(matches)
				user = await getUserViewByNumber(parseInt(matches[1], 10));
			else if(term.indexOf('@') > -1)
				user = await getUserViewByEmail(term);
			else
			{
				this.searchResults = await searchUserViewsByName(term);
				if(this.searchResults.length == 1)
				{
					user = this.searchResults[0]
					this.searchResults = [];
				}
			}

			if(user)
			{
				navigate('/admin/user/' + user.id, { user })
			}
			else if(this.searchResults.length == 0)
			{
				showToast({
					message: 'Not found',
					style: 'bg-danger'
				})
			}
			hideLoading()
		},
		show: function(opts)
		{
			this.searchTerm = "";
		},
		certLevelToLevel
	}
}

</script>
<template>
	<div v-if="ready" class="container py-5">
		<div class="row">

			<div class="col">
				<div class="card">
					<div class="card-body">
						<form @submit.prevent="search">
							<legend>Search criteria</legend>
							<div class="row">
								<div class="col">
									<div class="form-group mb-0">
										<input type="search" class="form-control" v-model="searchTerm" autocomplete="off" placeholder="e.g. member@example.com, #1234, first last" required />
										<span class="invalid-feedback"></span>
										<span class="form-text text-muted small mb-0">Partial name search works from the start of a name only. To find Andrew; use "and" not "rew"</span>
									</div>
								</div>
								<div class="col-auto">
									<button type="submit" ref="btnSearch" class="btn btn-primary">Search <span class="fe fe-search"></span></button>
								</div>
							</div>
						</form>
						<div v-if="searchResults.length" class="mt-4">
							<h3 >Results</h3>
							<div class="list-group list-group-flush">
								<div class="list-group-item" v-for="user in searchResults">
									<div class="row align-items-center">
										<div class="col">
											{{ user.name }}
										</div>
										<div class="col-auto">
											{{ user.email }}
										</div>
										<div class="col-auto">
											{{ certLevelToLevel(user.level) }}
										</div>
										<div class="col-auto">
											<a :href="`/admin/user/${user.id}`" class="btn btn-primary btn-sm">View <span class="fe fe-arrow-right-circle"></span></a>	
										</div>
									</div>
								</div>
							</div>
						</div>	
					</div>
				</div>
				<div class="card">
					<div class="card-body">
						<a href="/admin/insurance-checker" class="btn btn-outline-primary mr-2">Insurance checker <span class="fe fe-shield"></span></a>
						<a href="/admin/email-campaigns" class="btn btn-outline-primary mr-2">Email members <span class="fe fe-send"></span></a>
						<a href="/admin/reports" class="btn btn-outline-primary mr-2">Reports <span class="fe fe-bar-chart-2"></span></a>
						<a href="/admin/reports/newly-awarded" class="btn btn-outline-primary mr-2">Newly Awarded <span class="fe fe-bar-chart-2"></span></a>
					</div>
				</div>
				<div class="card">
					<div class="card-header">
						<h4 class="card-header-title">Certification Attempts</h4>
					</div>
					<table class="table card-table" v-if="pendingAttempts.length">
						<thead>
							<tr>
								<th scope="col">Date</th>
								<th scope="col">Name</th>
								<th scope="col">Level</th>
								<th scope="col">Flight</th>
								<th scope="col" class="shrink"></th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="attempt in pendingAttempts">
								<td>{{ attempt.submittedOn.format('yyy/MM/dd') }}</td>
								<td>{{ attempt.userName }}</td>
								<td>{{ attempt.level }}</td>
								<td>{{ attempt.flight }}</td>
								<td><a :href="`/admin/user/${attempt.userId}/attempt/${attempt.id}`" class="btn btn-primary">View attempt <span class="fe fe-arrow-right-circle"></span></a></td>
							</tr>
						</tbody>
					</table>
					<div class="card-body" v-else>
						<p class="mb-0">There are no pending certification attempts.</p>
					</div>
				</div>
				<div class="card">
					<div class="card-header">
						<h4 class="card-header-title">MAP Attempts</h4>
					</div>
					<table class="table card-table" v-if="pendingMAPAttempts.length">
						<thead>
							<tr>
								<th scope="col">Date</th>
								<th scope="col">Name</th>
								<th scope="col" class="shrink"></th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="attempt in pendingMAPAttempts">
								<td>{{ attempt.submittedOn.format('yyy/MM/dd') }}</td>
								<td>{{ attempt.userName }}</td>
								<td><a :href="`/admin/user/${attempt.userId}/map-attempt/${attempt.id}`" class="btn btn-primary">View attempt <span class="fe fe-arrow-right-circle"></span></a></td>
							</tr>
						</tbody>
					</table>
					<div class="card-body" v-else>
						<p class="mb-0">There are no pending MAP attempts.</p>
					</div>
				</div>
				<div class="card">
					<div class="card-header">
						<h4 class="card-header-title">Record Attempts</h4>
					</div>
					<table class="table card-table" v-if="pendingRecordAttempts.length">
						<thead>
							<tr>
								<th scope="col">Date</th>
								<th scope="col">Name</th>
								<th scope="col" class="shrink"></th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="attempt in pendingRecordAttempts">
								<td>{{ attempt.submittedOn.format('yyy/MM/dd') }}</td>
								<td>{{ attempt.userName }}</td>
								<td><a :href="`/admin/user/${attempt.userId}/record-attempt/${attempt.id}`" class="btn btn-primary">View attempt <span class="fe fe-arrow-right-circle"></span></a></td>
							</tr>
						</tbody>
					</table>
					<div class="card-body" v-else>
						<p class="mb-0">There are no pending Record attempts.</p>
					</div>
				</div>
			</div>
		</div>
    </div>
</template>
